import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import Globalize from '@sprinx/globalize';
import forLocale from '../utils/forLocale';
var localeFmt = {};

var createCurrencyFormatter = function createCurrencyFormatter(currency, options) {
  return Globalize.currencyFormatter(currency, _extends({
    style: 'symbol',
    symbolForm: 'narrow',
    round: 'round'
  }, options));
};

var extractCurrencyCode = function extractCurrencyCode(c) {
  return typeof c === 'string' ? c.split('-')[0] : c;
};

var currencyCode = function currencyCode(currency) {
  if (typeof currency === 'string') {
    return extractCurrencyCode(currency);
  }

  if (_typeof(currency) === 'object' && currency !== null && currency.code) {
    return extractCurrencyCode(currency.code);
  }

  return 'EUR';
};

var getFormatter = function getFormatter(fmt, currency, options) {
  var key = "".concat(currency).concat(options ? JSON.stringify(options) : '');

  if (!fmt[key]) {
    fmt[key] = createCurrencyFormatter(currency, options);
  }

  return fmt[key];
};
/**
 * @param {number | Object} amountOrObject Hodnota, nebo Objekt s hodnotou a menou
 * @param {number} amountOrObject.amount
 * @param {string} amountOrObject.currency kod meny.
 * @param {string | Object} [currency] String s kodem meny, nebo Object s propertou `code`.
 * @param {string | Object} currency.code Kod meny
 *
 * @returns {string}
 */


var currencyFormatter = function currencyFormatter(amountOrObject, currency, options) {
  return forLocale(localeFmt, {}, function (fmt) {
    var _ref = amountOrObject && _typeof(amountOrObject) === 'object' ? amountOrObject : {
      currency: currency,
      amount: amountOrObject
    },
        amount = _ref.amount,
        crr = _ref.currency;

    if (typeof amount !== 'number' || Number.isNaN(amount)) {
      return '';
    }

    var formatter = getFormatter(fmt, currencyCode(crr), options);
    return formatter(amount);
  });
};

export default currencyFormatter;